import React from "react";

import TextInput from '../../components/form/TextInput';
import SelectAjax from "../../components/form/SelectAjax";
import Random from "../../utils/strings/Random";
import ReactDOM from "react-dom";
import Ws from '../../config/Ws';
import Listagem from "../blocos/Listagem";
import Alert from "../../components/alert/Alert";
import SimpleAlert from "../../components/alert/types/SimpleAlert";
import TextArea from "../../components/form/TextArea";
import STRINGS from './../../data/language/language';

class Component extends React.Component {
  constructor(props){
    super(props);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.removeItemList = this.removeItemList.bind(this);

    this.state = {
      strings:STRINGS[window.LANGUAGE],
      wrapper:Random(7),
      listagemClass:"listagem",
      itemClass:"item-listagem",
      exercicios: props.exercicios ? props.exercicios : [],
      detalhe: props.detalhe ? props.detalhe : {},
      local_treino: props.detalhe ? (props.detalhe.local_treino ? props.detalhe.local_treino : 'academia') : 'academia',
    };
  }

  componentDidMount() {

  }

  componentWillUnmount() {

  }

  handleInputChange(event){
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
      local_treino: value
    });

  }


  removeItemList (e){
    e.preventDefault();

   const _item = e.target.closest("."+this.state.itemClass);
    const _id = _item.getAttribute("data-id");

    var array = [...this.state.detalhe.exercicios]; // make a separate copy of the array
    array.map((value,i)=>{
      if(value.value==_id){
        array.splice(i,1);
        let detalhe = {...this.state.detalhe};
        detalhe.exercicios = array
        this.setState({detalhe: detalhe});
      }
    });
  }

  handleSelectChange = (newValue) => {
    var check;
    var exercicios = [];

    const { atencao, exerciciosJaAdiconado } = this.state.strings;

    if(this.state.detalhe && this.state.detalhe.exercicios){
      //checa se o exercício já foi adicionado na listagem
      this.state.detalhe.exercicios.map((item,i)=>{
        if(newValue.value==item.value){
          check = true;
        }
      });
      exercicios = this.state.detalhe.exercicios;
    }

    if(!check){
      const detalhe = {...this.state.detalhe};
      const exerciciosModificados = [...exercicios, newValue];
      detalhe.exercicios = exerciciosModificados;
      this.setState({detalhe: detalhe});
    }else{
      let modal = new Alert();
      modal.open(
        {
          page:
          <SimpleAlert
            title={atencao}
            message={exerciciosJaAdiconado} />,
          animation:Alert.ANIMATION_INCREASE
        });
    }
  };

  getTreinoCasa(){
    const {
      dataInicio,
      dataFim,
      treinoDomiciliar,
      nomeTreinoDomiciliar,
      observacoes,
      salvar,
      digiteAqui,
      sexo,
      circuito,
      repeticoes,
      cadenciaTitle,
      sessoes
    } = this.state.strings;

    const circuitoVal = this.state.detalhe.circuito;
    const repeticoesVal = this.state.detalhe.repeticoes;
    const sessoesVal = this.state.detalhe.sessoes;
    const cadenciaVal = this.state.detalhe.cadencia;

    return (
      <div>
        <div className="pure-u-6-24">
          <TextInput
            name="circuito"
            title={circuito}
            placeholder={digiteAqui}
            value={circuitoVal}
          />
        </div>
        <div className="pure-u-6-24">
          <TextInput
            name="repeticoes"
            title={repeticoes}
            placeholder={digiteAqui}
            value={repeticoesVal}
          />
        </div>
        <div className="pure-u-6-24">
          <TextInput
            name="sessoes"
            title={sessoes}
            placeholder={digiteAqui}
            value={sessoesVal}
          />
        </div>
        <div className="pure-u-6-24">
          <TextInput
            name="cadencia"
            title={cadenciaTitle}
            placeholder={digiteAqui}
            value={cadenciaVal}
          />
        </div>
      </div>
    );
  }

  getTreinoAcademia(){
    const exercicios = this.state.detalhe ? this.state.detalhe.exercicios : [];
    const {cadencia,repeticoes,intervalo,dias_semana,id} = this.state.detalhe ? this.state.detalhe : {};
    const observacoesBloco = this.props.detalhe ? this.props.detalhe.observacoes : '';

    const
    {
      observacoes,
      cadenciaTitle,
      intervaloTitle,
      seriesRepeticoes,
      digiteAqui,
      selecioneExercicios,
      diaSemanaTitle,
      nenhumItem,
      tipoBloco,
      treinoCasa,
      treinoAcademia
    } = this.state.strings;
    return (
      <div>
        <div className="pure-u-8-24">
          <TextInput
            name="cadencia"
            value={cadencia}
            title={cadenciaTitle}
            placeholder={digiteAqui}>
          </TextInput>
        </div>
        <div className="pure-u-8-24">
          <TextInput
            name="repeticoes"
            value={repeticoes}
            title={seriesRepeticoes}
            placeholder={digiteAqui}>
          </TextInput>
        </div>
        <div className="pure-u-8-24">
          <TextInput
            name="intervalo"
            value={intervalo}
            title={intervaloTitle}
            placeholder={digiteAqui}>
          </TextInput>
        </div>
      </div>
    );
  }

  render (){
    //--------------------------------
    const exercicios = this.state.detalhe ? this.state.detalhe.exercicios : [];
    const {cadencia,repeticoes,intervalo,dias_semana,id} = this.state.detalhe ? this.state.detalhe : {};
    const observacoesBloco = this.props.detalhe ? this.props.detalhe.observacoes : '';

    const
    {
      observacoes,
      cadenciaTitle,
      intervaloTitle,
      seriesRepeticoes,
      digiteAqui,
      selecioneExercicios,
      diaSemanaTitle,
      nenhumItem,
      tipoBloco,
      treinoCasa,
      treinoAcademia
    } = this.state.strings;

    const exerciciosSearch = Ws.exercicios.search;
    const sexoStr = this.props.sexo;
    const search = {genero:sexoStr ? sexoStr.toUpperCase() : '' };
    const local_treinoBox = this.state.local_treino === 'academia' ? this.getTreinoAcademia() : this.getTreinoCasa();
    const key = new Date().getTime();

    //--------------------------------
    return(
      <div id={this.state.wrapper}>
        <a data-position={this.props.position} onClick={this.props.onRemoveHandler} href='#' className='buton-remove-bloco js-remove-bloco--bloco buton-remove-bloco--bloco'><i className="fas fa-times"></i></a>
        <input type='hidden' name='id' value={id} />
        <div className="">
          <TextArea
            name="observacoes"
            title={observacoes}
            value={observacoesBloco}
            placeholder="">
          </TextArea>
        </div>
        <div className='box-sexo-title'>
          <div className='box-title'>
            <span className='title-box-title'>{tipoBloco}</span>
          </div>

          <div className='box-tipo-bloco'>
            <div class='box-tipo-bloco__blocker'></div>
            <input type='hidden' name='local_treino' value={this.state.local_treino} />
            <div className="pure-u-1-2 problema-item">
              <input
                name={`${key}local_treino`}
                value="academia"
                type="radio"
                checked={this.state.local_treino==='academia'}
                onChange={this.handleInputChange}
              />
              <span className='type-pay-txt'>{treinoAcademia}</span>
            </div>
            <div className="pure-u-1-2 problema-item">
              <input
                value="casa"
                name={`${key}local_treino`}
                type="radio"
                checked={this.state.local_treino==='casa'}
                onChange={this.handleInputChange}
              />
              <span className='type-pay-txt'>{treinoCasa}</span>
            </div>
          </div>
        </div>
        <br />
        {local_treinoBox}
        <div className="pure-u-15-24">
          <SelectAjax
            data={search}
            noResultsText={nenhumItem}
            onChange={this.handleSelectChange}
            url={exerciciosSearch}
            title={selecioneExercicios} />
        </div>
        <div className="pure-u-8-24">
          <TextInput
            name="dias_semana"
            value={dias_semana}
            title={diaSemanaTitle}
            placeholder={digiteAqui}>
          </TextInput>
        </div>
        <br />
        <div className="separador"></div>
        <div className="listagem">
          <Listagem
            btRemoveClick={this.removeItemList}
            exercicios={exercicios}>
          </Listagem>
        </div>
      </div>
    )
  }
}

export default Component;



// WEBPACK FOOTER //
// ./src/classes/blocos/Component.js